import styled from 'styled-components'
import { TOP_NAV_HEIGHT } from '~/constants/config'
import { light, spacing } from '~/constants/theme'

export const ButtonsWrapper = styled.div`
  margin: 15px 0;
  display: flex;
  justify-content: center;
`

export const LabelWrapper = styled.div`
  height: 7%;
  width: 100%;
  display: flex;
  align-items: flex-end;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  height: ${TOP_NAV_HEIGHT};
  padding: ${spacing.spacingXL} ${spacing.spacingXL} ${spacing.spacingXL} 0;
  background-color: ${light.gray200};
  border-bottom: 2px solid ${light.gray400};
`

export const Details = styled.div`
  min-width: 0px;
  width: 100%;
  margin-right: ${spacing.spacingXL};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 1.25rem;
`

export const SubHeading = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
  background: ${light.gray300};
`

export const Content = styled.div`
  background: #ededf2;
  display: flex;
  flex-flow: column;
  width: 100%;
  height: 100%;
`
